function generateRandomString() {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    const charactersLength = characters.length;
    for (let i = 0; i < 8; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    // result 增加 yyyymmdd 年月日前缀
    const now = new Date();
    const pad = (n) => String(n).padStart(2, '0');
    result = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}` + result;
    return result;
}

function formatDateTime(val) {
    if (!val) return '';
    const d = new Date(val)
    if (isNaN(d.getTime())) return val;
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
}
module.exports = {
    generateRandomString,
    formatDateTime
}   